import * as React from "react"
import { graphql } from "gatsby"
import HeroSection from "../components/Global/HeroSection"
import Layout from "../components/layout"
import Seo from "../components/seo"
import InfoBlock from "../components/Global/InfoBlock"
import Contact from "../components/Contact/Contact"

import "../components/bootstrap.min.css"
import "../components/layout.css"

const ContactPage = ({ data }) => (
  <Layout>
    <Seo title="Contact" />
    <HeroSection
      img={data.img.childImageSharp.fluid}
      title="contact us"
      subtitle=""
      heroclass="contact-background"
      page="/contact"
    />
    <InfoBlock
      heading="how can we help?"
      photo={data.photo.childImageSharp.fluid}
    />
    <Contact photo={data.photo.childImageSharp.fluid} />
  </Layout>
)
export const query = graphql`
  {
    img: file(relativePath: { eq: "contact.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
    photo: file(relativePath: { eq: "contact.png" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid_tracedSVG
        }
      }
    }
  }
`
export default ContactPage
